import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Stack,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useLanguage } from "../../context/LanguageContext";

const LegalDocuments = () => {
  const { language, translations } = useLanguage();

  const documentss = [
    { label: translations[language]?.leagcard1, url: "/Pdf/updateTerm.pdf" },
    // { label: translations[language]?.leagcard2, url: "/Pdf/web.pdf" },
    // { label: translations[language]?.leagcard3, url: "/Pdf/doc3.pdf" },
    { label: translations[language]?.leagcard4, url: "/Pdf/newOrder.pdf" },
    { label: translations[language]?.leagcard5, url: "/Pdf/newRisk.pdf" },
    // { label: translations[language]?.leagcard6, url: "/Pdf/doc6.pdf" },
    { label: translations[language]?.leagcard7, url: "/Pdf/updateCompline.pdf" },
    // { label: "KYC YML Terms and Condition", url: "/Pdf/hand.pdf" },

  ];

  const documents = [
    { label: translations[language]?.leagcard1, url: "/Pdf/terms.pdf" },
    { label: translations[language]?.leagcard2, url: "/Pdf/web.pdf" },
    { label: translations[language]?.leagcard3, url: "/Pdf/doc3.pdf" },
    { label: translations[language]?.leagcard4, url: "/Pdf/neeeeeew.pdf" },
    { label: translations[language]?.leagcard5, url: "/Pdf/updateRisk.pdf" },
    { label: translations[language]?.leagcard6, url: "/Pdf/doc6.pdf" },
    { label: translations[language]?.leagcard7, url: "/Pdf/updateCompline.pdf" },
    { label: "KYC YML Terms and Condition", url: "/Pdf/hand.pdf" },

  ];


  const Section = ({ title }) => (
    <>
    <Box mb={6}>
      <Typography
        variant="h3"
        color="primary.main"
        gutterBottom
        style={{ fontWeight: "400", fontSize: "27px", color: "#2494C9" }}
      >
        {title}
      </Typography>
      <Typography
        variant="h3"
        fontWeight="bold"
        mb={3}
        style={{ color: "#1A1C1E", paddingBottom: "15px" }}
      >
        {translations[language]?.legalMainHead}
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 4 }}
        justifyContent={"start"}
      >
      {documentss?.map((doc, index) => (
  <Grid
    item
    xs={12}
    sm={6}
    md={4}
    key={index}
    sx={{ width: { xs: 420, sm: 322, md: 430 } }}
  >
    <Card
      onClick={() => window.open(doc.url, "_blank")}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1.6,
        borderRadius: "18px",
        boxShadow: "none",
        cursor: "pointer",
        backgroundColor: "#F2F4F7",
        gap: 2.5,
      }}
    >
      <img
        src="/Images/docu.png"
        alt=""
        style={{ width: "55px", height: "55px" }}
      />
      <Typography
        flex={1}
        sx={{
          color: "#1A1C1E",
          fontSize: {
            xs: "16px",
            sm: "16px",
            md: "17px",
            lg: "18px",
          },
        }}
      >
        {doc.label}
      </Typography>
      <ArrowForwardIosIcon fontSize="small" color="action" />
    </Card>
  </Grid>
))}

      </Grid>
    </Box>
    <Box mb={6}>
      <Typography
        variant="h3"
        color="primary.main"
        gutterBottom
        style={{ fontWeight: "400", fontSize: "27px", color: "#2494C9" }}
      >
       Capital Markets Authority (CMA)
      </Typography>
      <Typography
        variant="h3"
        fontWeight="bold"
        mb={3}
        style={{ color: "#1A1C1E", paddingBottom: "15px" }}
      >
        {translations[language]?.legalMainHead}
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 4 }}
        justifyContent={"start"}
      >
      {documents?.map((doc, index) => (
  <Grid
    item
    xs={12}
    sm={6}
    md={4}
    key={index}
    sx={{ width: { xs: 420, sm: 322, md: 430 } }}
  >
    <Card
      onClick={() => window.open(doc.url, "_blank")}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1.6,
        borderRadius: "18px",
        boxShadow: "none",
        cursor: "pointer",
        backgroundColor: "#F2F4F7",
        gap: 2.5,
      }}
    >
      <img
        src="/Images/docu.png"
        alt=""
        style={{ width: "55px", height: "55px" }}
      />
      <Typography
        flex={1}
        sx={{
          color: "#1A1C1E",
          fontSize: {
            xs: "16px",
            sm: "16px",
            md: "17px",
            lg: "18px",
          },
        }}
      >
        {doc.label}
      </Typography>
      <ArrowForwardIosIcon fontSize="small" color="action" />
    </Card>
  </Grid>
))}

      </Grid>
    </Box>
    </>
  );

  return (
    <>
      <Box
        // mt={12}
        textAlign="center"
        mb={6}
        pt={{ xs: 13, sm: 19, md: 19 }}
        pb={6}
        px={{ xs: 3, sm: 5, md: 9 }}
        sx={{
          background: "linear-gradient(to bottom, #F3F5F7 0%, #F3F5F76B 40%)",
        }}
      >
        <Typography variant="h2" fontWeight="bold" gutterBottom>
          {translations[language]?.legalTitle}
        </Typography>
        <Typography
          maxWidth={{ xs: "1250", sm: "1560px", md: "1560px" }}
          mx="auto"
          mb={3}
          style={{
            color: "#000000B2",
            fontSize: "22px",
            color: "#212529c4",
            fontWeight: "400",
            fontFamily: "SF Pro Display",
            padding: "0px 15px 0px 15px",
          }}
        >
          {translations[language]?.legalTitleDes} <br />{" "}
          {translations[language]?.legalTitleDes1}
        </Typography>
        <Button
          disableRipple
          component="a"
          href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          sx={{
            backgroundColor: "#000",
            color: "#fff",
            textTransform: "none",
            px: 4,
            py: 2,
            borderRadius: "8px",
            fontSize: "16px",
            mb: 4,
            boxShadow: "none",
            mt: 2,
            color: "rgba(255, 255, 255, 1)",
            "&:hover": {
              backgroundColor: "#000",
              color: "#fff",
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none", // 🛑 no shadow on click
            },
          }}
        >
          {translations[language]?.legalButton}
        </Button>
      </Box>
      <Box
        bgcolor="#FFF"
        py={{ xs: 0, sm: 5, md: 5 }}
        px={{ xs: 3, sm: 5, md: 11 }}
      >
        <Section title={translations[language]?.lagalSemiTitle1} />
        {/* <Section title={translations[language]?.lagalSemiTitle2} />
        <Section title={translations[language]?.lagalSemiTitle3} /> */}
      </Box>
    </>
  );
};

export default LegalDocuments;
